/* global React */
/* ──────────────────────────────────────────────────────────────────────
   DzProjectCards — project proof cards for service pages (same card design
   as the home "Our work" section). A page shows them by setting
   data.projects in its content (eyebrow, title, lead, items[]).
   ────────────────────────────────────────────────────────────────────── */
function DzProjectCards({ data, id }) {
  if (!data || !data.items || !data.items.length) return null;
  const arrow = (
    <svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" className="dz-featured__arrow">
      <path d="M3 8h9M8 4l4 4-4 4" stroke="currentColor" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
  return (
    <section className="dz-featured" id={id} aria-label={data.eyebrow}>
      <div className="dz-featured__inner">
        <div className="dz-featured__head">
          <div className="dz-featured__head-left">
            <span className="dz-eyebrow">{data.eyebrow}</span>
            <h2 className="dz-featured__title">{data.titleLeading} <em>{data.titleAccent}</em></h2>
          </div>
          <p className="dz-featured__lead">{data.lead}</p>
        </div>
        <div className="dz-featured__grid">
          {data.items.map((p) => (
            <a key={p.slug} className="dz-featured__card" href={p.href}>
              <div className="dz-featured__media">
                <picture>
                  {p.img.small && <source type="image/avif" srcSet={p.img.large ? p.img.small + ' 800w, ' + p.img.large + ' 1600w' : p.img.small} sizes="(max-width: 600px) 92vw, (max-width: 960px) 46vw, 420px" />}
                  <img src={p.img.fallback} alt={p.alt} loading="lazy" decoding="async" width="800" height="500" />
                </picture>
              </div>
              <div className="dz-featured__body">
                <span className="dz-featured__tag">{p.tag}</span>
                <h3 className="dz-featured__name">{p.name}</h3>
                <p className="dz-featured__desc">{p.desc}</p>
                <span className="dz-featured__link">{data.linkLabel} {arrow}</span>
              </div>
            </a>
          ))}
        </div>
        {data.allHref && (
          <div className="dz-featured__foot">
            <a className="dz-featured__all" href={data.allHref}>{data.allLabel} {arrow}</a>
          </div>
        )}
      </div>
    </section>
  );
}

window.DzProjectCards = DzProjectCards;
